import { queryOptions } from '@tanstack/react-query';
import type { CourierParams } from '../model/schema';
import { courierApi } from './courier-api';

export const courierKeys = {
  all: ['couriers'] as const,
  lists: () => [...courierKeys.all, 'list'] as const,
  list: (params?: CourierParams) => [...courierKeys.lists(), params] as const,
  counts: () => [...courierKeys.all, 'counts'] as const,
};

export const courierQueries = {
  list: (params?: CourierParams) =>
    queryOptions({
      queryKey: courierKeys.list(params),
      queryFn: () => courierApi.list(params),
    }),
  counts: () =>
    queryOptions({
      queryKey: courierKeys.counts(),
      queryFn: () => courierApi.counts(),
    }),
};
